<div style="overflow-y: hidden;">
  <div *ngIf="isMA || isNGS">
    <nav class="navbar navbar-expand-lg navbar-dark navbar-default" aria-label="Navbar">
      <!-- +++++ HEADER = BRANDING = Title of the site  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
      <div class="navbar-header flex flex-column justify-content-start">
        <div class="">
          <a class="navbar-brand text-2xl font-bold" href="#">Blueberry</a>
        </div>
        <div class=" header-lab-label">
          <span>{{selectedLab.label}}</span>
        </div>
        <div>
        <!-- BUILD INFORMATION -->
        <p [hidden]="production" id="buildInfo" (click)="showBuildInfo($event, buildInfoOverlay)" (keypress)="showBuildInfo($event, buildInfoOverlay)"
          style="color:white; width: 100px; text-align: left;">
          {{buildNo}}
        </p>
        <p-overlayPanel #buildInfoOverlay [hidden]="production">
          <ul id="buildOverlay">
            <li> Samples Processing Service: {{sampleProcessingServiceBuildNo}}</li>
            <li> Storage Service: {{storageServiceBuildNo}}</li>
            <li> MDM Service : {{mdmServiceBuildNo}}</li>
            <li> Delivery Service : {{deliveryServiceBuildNo}}</li>
            <li> NGS Samples Service : {{ngsSamplesProcessingServiceBuildNo}}</li>
            <li> Run Planning Service : {{runPlanningServiceBuildNo}}</li>
            <li> Result Evaluation Service : {{resultEvaluationServiceBuildNo}}</li>
          </ul>
        </p-overlayPanel>
        </div>
      </div>
      <!-- +++++ TOGGLER: will only display on narrow screen (mobile devices...) to allow user to access the menu +++++++++++++++++++++++++++++++++++++++++++ -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- +++++ TITLE BAR ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent" style="padding-left: 2rem">

        <!-- Standard main menu = left aligned -->
        <div class="mr-auto">
          <div class="ui-inputgroup">
            <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="30"
              (keydown.enter)="searchForPlate()" class="inputFields" id="plateID" placeholder="Scan Plate"/>
            <button pButton class="search-field-blue-end search-button" icon="fa fa-search" style="height: 2.5rem;" (click)="searchForPlate()"></button>
          </div>
        </div>

        <!-- Special menu = right aligned -->
        <ul class="navbar-nav navbar-right">
          <!-- ADMINISTRATION -->
          <li class="nav-item" style="padding-right: 1rem; padding-top: 0.4rem;">
            <button class="btn header-change-lab-btn" (click)="changeLab()">Change Lab</button>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/masterdata" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
              <em class="fa fa-fw fa-gears fa-lg"></em>
            </a>
          </li>
          <li *ngIf="loginStatus" class="nav-item">
            <a class="nav-link" routerLink="/logout" routerLinkActive="activatedRouterLink" (click)="logOut()">
              <em class="fa fa-fw fa-sign-out fa-lg"></em>
            </a>
          </li>
          <li *ngIf="azureLoginStatus" class="nav-item">
            <a class="nav-link"  (click)="azureLogOut()">
              <em class="fa fa-fw fa-sign-out fa-lg"></em>
            </a>
          </li>
          <!-- SUPPORT TICKET -->
        </ul>
      </div>
      <div class="topright" *ngIf="azureLoginStatus"  >
        {{loggedUserName}}<em class="fa fa-user" style="margin-left: 5px;" aria-hidden="true"></em>
    </div>
    </nav>
  </div>
  <messages class="message-service"></messages>
    
  <div class="flex w-full" style="overflow-y: hidden; top:75px; position: fixed;">
    <div class="left-nav flex flex-column">
      <div *ngIf="isMA" #overlayTargetMA class="top-menu-overlay-target-ma">
      </div>
      <div *ngIf="isNGS" #overlayTargetNGS class="top-menu-overlay-target-ngs">
      </div>
      <div *ngIf="isMA" [ngClass]="getSideNavStyle()" (mouseenter)="extendSideNav($event, 'MA')">
        <div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('apg-delivery-box-manager')?'menu-item-selected':''" (click)="openComponent(0)" routerLink="apg-delivery-box-manager" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-fw fa-truck"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('reception')?'menu-item-selected':''" (click)="openComponent(1)" routerLink="reception" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-fw fa-barcode"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('preparation')?'menu-item-selected':''" (click)="openComponent(2)" routerLink="preparation" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-object-group"></em> </a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('samples')?'menu-item-selected':''" (click)="openComponent(3)" routerLink="samples" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-fw fa-barcode"></em> </a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('Admin-Search')?'menu-item-selected':''" (click)="openComponent(4)" routerLink="Admin-Search" routerLinkActive="activatedRouterLink">
                <em class="fa fa-lock side-menu-lock-em"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('Status-Screen')?'menu-item-selected':''" (click)="openComponent(5)" routerLink="Status-Screen" routerLinkActive="activatedRouterLink">
                <em class="fa fa-table"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('machines')?'menu-item-selected':''" (click)="openComponent(6)" routerLink="machines" routerLinkActive="activatedRouterLink">
                <em class="fa fa-tasks"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('Storage')?'menu-item-selected':''" (click)="openComponent(7)" routerLink="Storage" routerLinkActive="activatedRouterLink">
                <em class="fa fa-fw fa-cube"></em></a>
            </div>
          </div>
        </div>
        <div>
          <p-overlayPanel #menuItemsPanelMA [style]="overrideOverlayStyle" [showTransitionOptions]="'0.2ms'" [hideTransitionOptions]="'0.2ms'">
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('apg-delivery-box-manager')?'menu-item-selected':''" (click)="openComponent(0)" routerLink="apg-delivery-box-manager" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Delivery</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('reception')?'menu-item-selected':''" (click)="openComponent(1)" routerLink="reception" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Reception</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('preparation')?'menu-item-selected':''" (click)="openComponent(2)" routerLink="preparation" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Preparation</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('samples')?'menu-item-selected':''" (click)="openComponent(3)" routerLink="samples" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Samples</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Admin-Search')?'menu-item-selected':''" (click)="openComponent(4)" routerLink="Admin-Search" routerLinkActive="activatedRouterLink">
                  Admin</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Status-Screen')?'menu-item-selected':''" (click)="openComponent(5)" routerLink="Status-Screen" routerLinkActive="activatedRouterLink">
                  Status Screen</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('machines')?'menu-item-selected':''" (click)="openComponent(6)" routerLink="machines" routerLinkActive="activatedRouterLink">
                  Machines</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Storage')?'menu-item-selected':''" (click)="openComponent(7)" routerLink="Storage" routerLinkActive="activatedRouterLink">
                  Storage</a>
              </div>
            </div>
          </p-overlayPanel>
        </div>
      </div>
      <div *ngIf="isNGS" [ngClass]="getSideNavStyle()" (mouseenter)="extendSideNav($event, 'NGS')">
        <div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('apg-delivery-box-manager')?'menu-item-selected':''" (click)="openComponent(0)" routerLink="apg-delivery-box-manager" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-fw fa-truck"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('NG-reception')?'menu-item-selected':''" (click)="openComponent(1)" routerLink="NG-reception" routerLinkActive="activatedRouterLink">
                <em class="fa fa-barcode"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('process')?'menu-item-selected':''" (click)="openComponent(2)" routerLink="process" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                <em class="fa fa-fw fa-barcode"></em> </a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('Admin-Search')?'menu-item-selected':''" (click)="openComponent(3)" routerLink="Admin-Search" routerLinkActive="activatedRouterLink">
                <em class="fa fa-lock side-menu-lock-em"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('Run')?'menu-item-selected':''" (click)="openComponent(4)" routerLink="Run" routerLinkActive="activatedRouterLink">
                <em class="fa fa-times"></em></a>
            </div>
          </div>
          <div class="row side-menu-item">
            <div class="col-md-9 menu-item-label-collapsed">
              <a class="side-menu-link" [ngClass]="showComponentNotch('plate-status')?'menu-item-selected':''" (click)="openComponent(5)" routerLink="plate-status" routerLinkActive="activatedRouterLink">
                <em class="fa fa-table"></em></a>
            </div>
          </div>
        </div>
        <div>
          <p-overlayPanel #menuItemsPanelNGS [style]="overrideOverlayStyle" [showTransitionOptions]="'0.2ms'" [hideTransitionOptions]="'0.2ms'">
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('apg-delivery-box-manager')?'menu-item-selected':''" (click)="openComponent(0)" routerLink="apg-delivery-box-manager" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Delivery</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('NG-reception')?'menu-item-selected':''" (click)="openComponent(1)" routerLink="NG-reception" routerLinkActive="activatedRouterLink">
                  Reception</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('process')?'menu-item-selected':''" (click)="openComponent(2)" routerLink="process" routerLinkActive="activatedRouterLink" [hidden]="disableHeaderforUser()">
                  Process</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Admin-Search')?'menu-item-selected':''" (click)="openComponent(3)" routerLink="Admin-Search" routerLinkActive="activatedRouterLink">
                  Admin</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Run')?'menu-item-selected':''" (click)="openComponent(4)" routerLink="Run" routerLinkActive="activatedRouterLink">
                  Run</a>
              </div>
            </div>
            <div class="row side-menu-item">
              <div class="col-md-12 menu-item-label">
                <a class="side-menu-link" [ngClass]="showComponentNotch('Status-Screen')?'menu-item-selected':''" (click)="openComponent(5)" routerLink="Status-Screen" routerLinkActive="activatedRouterLink">
                  Status Screens</a>
              </div>
            </div>
          </p-overlayPanel>
        </div>
      </div>
    </div>
    <div class="page-content-collapsed" (mouseenter)="collapseSideNav()">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>